import { pipe } from 'fp-ts/lib/function';
import {
  ApplicationEstateInfoDto,
  TenantCreditStudyDto,
} from '../../infrastructure';
import { InitUnderwritingAsTenantCommand } from '../commands';
import {
  AdministrationPrice,
  CreditStudyResult,
  EstateApplicationInfo,
  EstateId,
  UserId,
} from '../models';
import { Price } from '../models/types/price.type';
import { EstateDetails } from './../../../Shared';
import { option } from 'fp-ts';

export const estateApplicationToBackModel = (
  estate: ApplicationEstateInfoDto
): InitUnderwritingAsTenantCommand => ({
  estateInfo: new EstateApplicationInfo(
    new EstateId(estate.estateId),
    new AdministrationPrice(estate.admonPrice),
    new Price(estate.rentalPrice),
    pipe(option.fromNullable(estate.broker), option.map(UserId.of))
  ),
  tenant: {
    id: -1,
  },
});

export const mapEstateInfo = (
  estateDetails: EstateDetails
): ApplicationEstateInfoDto => {
  const estateInfo: ApplicationEstateInfoDto = {
    estateId: estateDetails.id,
    admonPrice: estateDetails.administrationPrice,
    rentalPrice: estateDetails.price,
    broker: estateDetails.broker,
  };
  return estateInfo;
};

export const mapCreditStudy = (
  creditStudyResult: CreditStudyResult
): TenantCreditStudyDto => {
  return {
    id: creditStudyResult.creditStudyId.value,
    status: creditStudyResult.result,
    maxPaymentCapacity: creditStudyResult.maxRentApproved?.value || 0,
  };
};
